export enum ActionTypes {
  SET_APP_LOADING = 'SET_APP_LOADING',
  SET_USER = 'SET_USER',
  SET_CURRENT_PROJECT_FOR_REPORT = 'SET_CURRENT_PROJECT_FOR_REPORT',
  CLEAR_STATE = 'CLEAR_STATE',
}
